module.exports = __webpack_public_path__ + "img/b5.dd0505eb.png";